<!--
 * @Author: yyl
 * @Date: 2025-06-25 10:38:33
 * @LastEditTime: 2025-08-21 16:03:46
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/views/HomeView.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="container">
    <!-- 轮播图 -->
    <el-carousel
      ref="carouselRef"
      indicator-position="none"
      :height="`${carouselHeight}px`"
    >
      <el-carousel-item v-for="item in banner" :key="item.url">
        <el-image
          :src="item.url"
          :style="{
            width: `${carouselWdith}px`,
            height: `${carouselHeight}px`,
          }"
          fit="cover"
          @click="handleCarouselClick(item)"
        />
      </el-carousel-item>
    </el-carousel>

    <!-- 内容  -->
    <div>
      <el-row>
        <el-row :gutter="18">
          <el-col :sm="24" :md="24" :lg="16">
            <CardTwoColumn :params="homeIntro.one || {}"></CardTwoColumn>
          </el-col>

          <el-col :sm="24" :md="24" :lg="8">
            <CardListDate :params="homeIntro.two || {}"></CardListDate>
          </el-col>
        </el-row>

        <el-row :gutter="18">
          <el-col :sm="24" :md="24" :lg="16">
            <CardTwoColumn :params="homeIntro.three || {}"></CardTwoColumn>
          </el-col>

          <el-col :sm="24" :md="24" :lg="8">
            <CardCalendar :params="homeIntro.calendar"></CardCalendar>
          </el-col>
        </el-row>

        <el-col :span="24" style="margin: 20px 0">
          <el-image
            :src="homeIntro.middle && homeIntro.middle.url"
            :style="{
              width: `${bannerWdith}px`,
              height: `${bannerHeight}px`,
            }"
            fit="cover"
            @click="handleCarouselClick(homeIntro.middle)"
          />
        </el-col>

        <el-row :gutter="18">
          <el-col :sm="24" :md="24" :lg="8">
            <CardOneColumn
              :params="homeIntro.four || {}"
              :hasTop="true"
            ></CardOneColumn>
          </el-col>

          <el-col :sm="24" :md="24" :lg="8">
            <CardOneColumn
              icon="reading"
              :params="homeIntro.five || {}"
            ></CardOneColumn>
          </el-col>

          <el-col :sm="24" :md="24" :lg="8">
            <CardOneColumn
              :params="homeIntro.six || {}"
              icon="s-home"
            ></CardOneColumn>
          </el-col>
        </el-row>

        <el-row :gutter="18">
          <el-col :sm="24" :md="24" :lg="8">
            <CardImage :params="homeIntro.seven || {}"></CardImage>

            <!-- <div class="card-title flex items-center content-space-between">
              <div class="card-title--left">
                <i :class="`el-icon-mouse`"></i>
                {{ (homeIntro.seven && homeIntro.seven.title) || "" }}
              </div>

              <div
                class="card-title--right"
                @click="handleGoListClick(homeIntro.seven)"
              >
                更多>
              </div>
            </div>

            <div>
              <el-image
                :src="
                  homeIntro.one &&
                  homeIntro.one.seven &&
                  homeIntro.one.seven[0] &&
                  homeIntro.one.seven[0].thumb_pic
                "
                style="width: 100%; height: auto"
              />
            </div>

            <div>
              {{
                homeIntro.one &&
                homeIntro.one.seven &&
                homeIntro.one.seven[0] &&
                homeIntro.one.seven[0].title
              }}
            </div> -->

            <!-- <CardOneColumn
            :params="homeIntro.seven || {}"
            :hasTop="true"
            icon="mouse"
          ></CardOneColumn> -->
          </el-col>

          <el-col :sm="24" :md="24" :lg="8">
            <CardOneColumn
              :params="homeIntro.eight || {}"
              :hasTop="true"
              icon="trophy"
            ></CardOneColumn>
          </el-col>

          <el-col :sm="24" :md="24" :lg="8">
            <CardMap :params="homeIntro.enroll || {}"></CardMap>
          </el-col>
        </el-row>

        <el-col :span="24">
          <CardGrid :params="homeIntro.nine || {}"></CardGrid>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import resizeMixin from "@/mixins/resize"

import { getHomeIntro } from "@/api/home"

import CardTwoColumn from "@/components/home/CardTwoColumn.vue"
import CardOneColumn from "@/components/home/CardOneColumn.vue"
import CardCalendar from "@/components/home/CardCalendar.vue"
import CardMap from "@/components/home/CardMap.vue"
import CardListDate from "@/components/home/CardListDate.vue"
import CardImage from "@/components/home/CardImage.vue"

import CardGrid from "@/components/home/CardGrid.vue"

export default {
  name: "HomeView",

  components: {
    CardTwoColumn,
    CardOneColumn,
    CardCalendar,
    CardMap,
    CardGrid,
    CardListDate,
    CardImage,
  },

  mixins: [resizeMixin],

  data() {
    return {
      homeIntro: {},

      carouselWdith: 1280,
      carouselHeight: 400,

      bannerWdith: 1280,
      bannerHeight: 200,

      banner: [],
    }
  },

  created() {
    // this.homeIntro = JSON.parse(localStorage.getItem("homeIntro"))

    this.loadIntro()
  },

  methods: {
    handleCarouselClick(item) {
      console.log(item)

      if (item.link) {
        window.open(item.link, "_blank")
      }
    },

    handleGoListClick(item) {
      console.log(item)

      if (item.content_model_id == 2) {
        this.$router.push({
          path: "/list",
          query: {
            section_id: String(item.section_id),
            title: item.title,
          },
        })
      } else if (item.content_model_id == 3) {
        this.$router.push({
          path: "/list-image",
          query: {
            section_id: String(item.section_id),
            title: item.title,
          },
        })
      } else if (item.content_model_id == 4) {
        this.$router.push({
          path: "/teachers",
          query: {
            section_id: String(item.section_id),
            title: item.title,
          },
        })
      }

      // this.$router.push(
      //   `/list?section_id=${this.params.section_id}&title=${this.params.title}`
      // )
    },

    onResize() {
      const carouselRef = this.$refs.carouselRef

      const carouselWdith = carouselRef.$el.offsetWidth

      this.carouselWdith = carouselWdith
      this.carouselHeight = (carouselWdith / 1280) * 400

      this.bannerWdith = carouselWdith
      this.bannerHeight = (carouselWdith / 1280) * 200
    },

    async loadIntro() {
      try {
        const res = await getHomeIntro()

        this.homeIntro = res

        console.log(res)

        this.banner = this.homeIntro.banner || []
      } catch (err) {
        console.error("加载学校简介失败", err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.section {
  margin-top: 20px;
}

.card-title {
  padding: 0 4px;
  border-bottom: 3px solid #b4d13d;
}

.card-title--left {
  color: #42679f;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  padding: 14px 0;
}

.card-title--right {
  font-size: 14px;
  line-height: 18px;
  text-align: right;
  padding: 14px 0;
  cursor: pointer;
}
</style>
